<!-- document-metadata-popup.component.html -->
<div class="popup-overlay" *ngIf="showPopup">
  <div class="popup-content">
    <h2>{{ documentName }} Metadata</h2>

    <!-- Dynamically render form fields based on metadata -->
    <form (ngSubmit)="submitForm()" #metadataForm="ngForm">
      <div *ngFor="let field of metadata">
        <div class="form-group">
          <label>{{ field.Name }}</label>

          <!-- Dynamic input generation based on datatype -->
          <ng-container [ngSwitch]="field.Datatype">
            <!-- Text Input (for string) -->
            <input *ngSwitchCase="'String'" type="text" class="form-control" [(ngModel)]="formData[field.Name]"
              name="{{ field.Name }}" [required]="field.Mandatory" [maxlength]="field.Datalength" />

            <!-- Number Input (for number) -->
            <input *ngSwitchCase="'Number'" type="number" class="form-control" [(ngModel)]="formData[field.Name]"
              name="{{ field.Name }}" [required]="field.Mandatory" [maxlength]="field.Datalength" />

            <!-- Checkbox (for boolean) -->
            <input *ngSwitchCase="'Boolean'" type="checkbox" class="form-check-input" [(ngModel)]="formData[field.Name]"
              name="{{ field.Name }}" />

            <!-- Default case for unsupported types -->
            <input *ngSwitchDefault type="text" class="form-control" [(ngModel)]="formData[field.Name]"
              name="{{ field.Name }}" [required]="field.Mandatory" [maxlength]="field.Datalength" />
          </ng-container>
        </div>
      </div>

      <!-- Wrapper for buttons -->
      <div class="button-container">
        <button type="submit" class="btn btn-primary" [disabled]="!metadataForm.valid">
          Next
        </button>
        <button (click)="closePopup()" class="btn btn-secondary">Close</button>
      </div>
    </form>
  </div>
</div>